import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-ml }}",{ moduleName: "embercom/templates/apps/app/automation/fin-ai-agent/sdr-configurator.hbs" })